<template>
  <div class="top-menu">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#FC9710"
      text-color="#fff"
      active-text-color="#fff"
    >
      <el-menu-item index="work">工作台</el-menu-item>
      <!-- <el-menu-item index="drug">药品订单管理</el-menu-item> -->
      <el-menu-item index="drugList">药品管理</el-menu-item>
      <el-menu-item index="user">个人中心</el-menu-item>
      <!-- <el-tooltip effect="dark" content="我的消息" placement="bottom">
        <el-button class="item" type="alert" @click="message()">
          <el-badge :value="msgIsRead" v-if="msgIsRead != 0">
            <i class="el-icon-message-solid"></i>
          </el-badge>
          <i class="el-icon-message-solid" v-else></i>
        </el-button>
      </el-tooltip> -->
      <el-tooltip effect="dark" content="全屏" placement="bottom">
        <el-button class="switch-btn" type="alert" @click="screen()">
          <i v-show="!fullscreen" class="el-icon-rank"></i>
          <img v-show="fullscreen" src="../../assets/images/zoom.png" alt />
        </el-button>
      </el-tooltip>
      <el-tooltip effect="dark" content="锁屏" placement="bottom">
        <el-button class="lock-btn" disabled type="alert" @click="lock()">
          <i v-show="isLock" class="el-icon-lock"></i>
          <i v-show="!isLock" class="el-icon-unlock"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip effect="dark" content="退出" placement="bottom">
        <el-button class="out-btn" type="alert" @click="out()">
          <i class="el-icon-switch-button"></i>
        </el-button>
      </el-tooltip>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import util from "@/utils";
export default {
  name: "tabs",
  props: {
    editableTabs: Array,
  },
  data() {
    return {
      activeIndex: "work",
      editableTab: this.editableTabs,
      isLock: true,
      fullscreen: false,
      passwd: "",
      box: false,
    };
  },
  computed: {
    ...mapGetters(["lockPasswd"]),
    ...mapState(["status", "profileStep"]),
    msgIsRead() {
      return this.$store.state.msgIsRead;
    },
  },

  mounted() {
    const that = this;
  },
  created() {
    this.getUrl();
  },
  methods: {
    /**
     * @param {Object} key
     * @param {Object} 暴露出去的路由
     */
    handleSelect(key, keyPath) {
      if (key === "work") {
        this.$router.push({
          path: "/index/work/appointment",
        });
      } else if (key === "drug") {
        this.$router.push({
          path: "/index/drug/index",
        });
      } else if (key === "drugList") {
        this.$router.push({
          path: "/index/drugList/index",
        });
      } else {
        this.$router.push({
          path: "/index/user/auditPrescription",
        });
      }
      // var urlName ='';
      // if (key === "user") {
      //   console.log("this.status:",this.status);
      //   console.log("this.profileStep:",this.profileStep);
      //   if (this.status === 0) {
      //     //待审核
      //     urlName = "/index/user/auditInformation/auditInfo";
      //     if (this.profileStep === 1 || this.profileStep === 2 || this.profileStep === 3){
      //       urlName = "/index/user/auditInformation/information";
      //     }
      //   }else if(this.status === 1){
      //     //审核通过
      //     urlName = "/index/user/auditInformation/information";
      //   }else if(this.status === -1) {
      //     //审核拒绝
      //     urlName = "/index/user/auditInformation/auditInfo";
      //   }
      //   console.log(urlName);
      // } else {
      //   this.$router.push({
      //     path: "/index/work/appointment"
      //   });
      // }
      // console.log(urlName);
      // this.$router.push({
      //   path: urlName,
      // });
    },
    go(url) {
      this.$router.push({
        path: url,
      });
    },
    /**
     * 通过获取路由最后地址来更改导航高亮
     */
    getUrl() {
      let currentUrl = window.location.href;
      this.activeIndex = currentUrl.split("#")[1].split("/")[2];
      console.log("this.activeIndex", this.activeIndex);
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 切换全屏
     */
    screen() {
      const that = this;
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      that.fullscreen = !that.fullscreen;
    },
    /**
     * 锁屏功能
     */
    lock() {
      const that = this;
      this.$confirm("开启锁屏, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //锁屏状态0，不允许跳转
          util.setStore("lockState", "0");
          util.setStore("lockPrePath", this.$route.path);
          that.elementTips("success", "锁屏成功");
          setTimeout(() => {
            that.go("/lock");
          }, 100);
        })
        .catch(() => {
          that.elementTips("info", "锁屏失败");
        });
    },

    /**
     * 退出功能
     */
    out() {
      const that = this;
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        util.removeStore("user_token");
        util.removeStore("user_mobile");
        util.removeStore("userType");
        util.removeStore("userInfo");
        util.removeStore("user_id");
        that.elementTips("success", "退出成功");
        setTimeout(function () {
          that.go("/login");
          that.$store.dispatch("logout");
        }, 2000);
      });
    },
    message() {
      const that = this;
      that.go("/index/user/news");
    },
  },
  watch: {
    /**
     * 监听路由变化，修改标题高亮指向
     * 为了解决首页点击消息进入user页面标题不对应问题
     * 缺点：但是只要路由变化就执行方法
     */
    $route: function () {
      this.getUrl();
    },
  },
};
</script>
<style>
.top-menu ul {
  display: flex;
  justify-content: center;
}

.top-menu .item {
  margin-right: 40px;
  position: absolute;
  right: 190px;
  text-align: center;
  font-size: 20px;
  /* padding: 2px 3px; */
  line-height: 30px;
  height: 100%;
}

.top-menu .el-icon-message-solid:before {
  content: "\E799";
  color: white;
}

.top-menu .item-btn {
  position: absolute;
  right: 250px;
  text-align: center;
  font-size: 20px;
  line-height: 15px;
  height: 100%;
}

.top-menu .switch-btn {
  position: absolute;
  right: 90px;
  text-align: center;
  font-size: 20px;
  line-height: 15px;
  height: 100%;
}
.top-menu .switch-btn img {
  width: 20px;
  height: 20px;
}

.top-menu .lock-btn {
  position: absolute;
  right: 160px;
  text-align: center;
  font-size: 20px;
  line-height: 15px;
  height: 100%;
}

.top-menu .out-btn {
  position: absolute;
  right: 20px;
  text-align: center;
  font-size: 20px;
  line-height: 15px;
  height: 100%;
}
</style>
